<template>
  <div>
    <transition name="el-zoom-in-top">
      <el-dialog :show-close="false" :visible.sync="$store.state.isCartShow">
        <div class="lineTitle fontPB">
          <div>{{ $t('cart.shop') }}</div>
          <div>
            <template v-if="$store.state.language=='zh-CN'||$store.state.language=='zh-TW'">-----</template>
            <template v-else>-------------</template>
          </div>
        </div>
        <div class="shopList" v-if="cartList.length>0">
          <el-row v-if="$store.state.isPC">
            <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4"></el-col>
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8" :offset="4">{{ $t('cart.detail') }}</el-col>
            <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="6">{{ $t('cart.qty') }}</el-col>
            <el-col :xs="24" :sm="4" :md="3" :lg="3" :xl="3">{{ $t('cart.price') }}</el-col>
          </el-row>
          <template v-for="(item,index) in cartList">
            <el-row class="proLine">
              <el-col :xs="8" :sm="4" :md="4" :lg="4" :xl="4">
                <el-image
                  style="height: 80px;margin-right: 10px;"
                  :src="item.shop_product_sku.sku_image_url"
                  fit="contain">
                </el-image>
              </el-col>
              <el-col :xs="16" :sm="6" :md="8" :lg="8" :xl="8">
                <div class="title fontPB">
                  <router-link :to="{ name: 'ProductDetail', params: { id: item.shop_product_sku.shop_product.id } }"
                               target="_blank">
                    {{ item.shop_product_sku.title }}
                  </router-link>
                </div>
              </el-col>
              <el-col :xs="8" :sm="6" :md="6" :lg="6" :xl="6">
                <div class="num fontPL">
                  <el-input-number v-model="item.amount"
                                   @change="(currentValue,oldValue)=>{handleChange(currentValue,oldValue,index)}"
                                   :min="1" :max="100" label="amount"></el-input-number>
                </div>
              </el-col>
              <el-col :xs="6" :sm="6" :md="4" :lg="4" :xl="4">
                <div class="price fontPL">
                  <span v-if="item.shop_product_sku.sales_price && item.shop_product_sku.shop_product.sales">
                    {{ $store.state.ccode }} {{ item.shop_product_sku.sales_price }}
                  </span>
                  <span v-else>{{ $store.state.ccode }} {{ item.shop_product_sku.price }}</span>
                </div>
              </el-col>
              <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                <i class="el-icon-close delete" @click="deleteShop(item.shop_product_sku_id)"></i>
              </el-col>
            </el-row>
          </template>
          <el-row>
            <el-col :xs="16" :sm="18" :md="18" :lg="18" :xl="18">
              <div class="rightText fontPL">
                {{ $t('cart.total') }}&nbsp;
              </div>
            </el-col>
            <el-col :xs="8" :sm="6" :md="6" :lg="6" :xl="6">
              <div class="rightPrice fontPL">
                {{ $store.state.ccode }} {{ totalPrice }}
              </div>
            </el-col>
          </el-row>
          <div class="btns fontPB">
            <button class="boxBtn check hv" @click="toShopCart()">{{ $t('cart.checkout') }}</button>
            <button class="boxBtn cancel hv" @click="$store.commit('changeCartShow',false)">{{
                $t('cart.back')
              }}
            </button>
          </div>
        </div>
        <div class="text" v-else>
          <h4>{{ $t('cart.empty') }}</h4>
        </div>
      </el-dialog>
    </transition>
  </div>
</template>
<script>
export default {
  data () {
    return {
      num: 1,
    };
  },
  mounted () {
  },
  methods: {
    deleteShop (id) {
      this.$confirm(this.$t('btnText.delCart'), this.$t('btnText.tip'), {
        confirmButtonText: this.$t('btnText.confirm'),
        cancelButtonText: this.$t('btnText.cancel'),
        type: 'warning',
      }).then(() => {
        this.$axios({
          method: 'DELETE',
          url: '/api/carts',
          headers: {
            'Authorization': localStorage.token_type + localStorage.token,
          },
          data: {
            shop_product_sku_id: id,
          },
        }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.$store.commit('getCartList');
        });
      });
    },
    handleChange (currentValue, oldValue, index) {
      let data = {
        index: index,
        num: currentValue,
        old: oldValue,
      };
      console.log(data);
      this.$store.commit('changeNum', data);
    },
    toShopCart () {
      this.$store.commit('changeCartShow', false);
      this.$router.push({ path: '/ShopCart' });
    },
  },
  computed: {
    cartList () {
      return this.$store.getters.cartList;
    },
    totalPrice () {
      return this.$store.getters.totalPrice;
    },
  },
};
</script>
<style scoped>
/deep/ .el-dialog {
  width : 70%;
}

/deep/ .el-input-number__increase, /deep/ .el-input-number__decrease, /deep/ .el-input-number__decrease.is-disabled {
  border-radius    : 50%;
  width            : 40px;
  height           : 40px;
  line-height      : 40px;
  background-color : #7B5C55;
  color            : #fff;
  font-size        : 20px;
}

/deep/ .el-input-number {
  width     : auto;
  max-width : 160px;
}

/deep/ .el-input__inner {
  border    : none;
  font-size : 20px;
  color     : #7B5C55;
}

/deep/ .el-dialog__body {
  padding-top : 10px;
  color       : #7B5C55;
}

.lineTitle {
  position    : relative;
  width       : 100%;
  height      : 60px;
  line-height : 60px;
  font-size   : 28px;
  color       : #7B5C55;
}

.lineTitle > div:first-child {
  height      : 40px;
  line-height : 40px;
  display     : inline-block;
  width       : auto;
  position    : absolute;
  top         : 10px;
  z-index     : 2;
}

.lineTitle > div:nth-child(2) {
  background  : #FFD0E0;
  display     : inline-block;
  width       : auto;
  position    : absolute;
  height      : 20px;
  line-height : 20px;
  top         : 30px;
  color       : #FFD0E0;
  z-index     : 1;
}

.shopList {
  padding   : 20px;
  font-size : 16px;
}

.proLine {
  min-height    : 90px;
  border-bottom : 2px #00000029 solid;
}

.title {
  font-size  : 20px;
  margin-top : 12px;
}

.proLine a {
  text-decoration : none;
  color           : inherit;
}

.num {
  font-size  : 24px;
  margin-top : 12px;
}

.price, .close {
  margin-top : 12px;
  font-size  : 24px;
}

.delete {
  font-size  : 30px;
  color      : red;
  margin-top : 12px;
}

.priceline {
  text-decoration : line-through;
  margin-right    : 5px;
  color           : #BABABA;
  font-size       : 14px;
  line-height     : 20px;
}

.rightText {
  line-height : 40px;
  width       : 100%;
  font-size   : 24px;
  text-align  : right;
}

.rightPrice {
  line-height : 40px;
  width       : 100%;
  font-size   : 24px;
}

.btns {
  width      : 100%;
  height     : 50px;
  margin-top : 15px;
}

.boxBtn {
  float         : right;
  height        : 50px;
  width         : 180px;
  border-radius : 25px;
  outline       : none;
  border        : none;
  line-height   : 50px;
  margin-right  : 20px;
  text-align    : center;
  color         : #fff;
  font-size     : 24px;
}

.check {
  background : rgb(154, 216, 218);
}

.cancel {
  background : #BABABA;
}

/*手机*/
@media screen and (max-width : 500px) {
  .price, .delete {
    line-height   : 40px;
    font-size     : 17px;
    margin-bottom : 10px;
  }
}

@media screen and (max-width : 768px) {
  /deep/ .el-dialog__header {
    padding : 0;
  }

  /deep/ .el-dialog {
    width : 95%;
  }

  .lineTitle {
    font-size : 24px;
  }

  .loginBox {
    display : block;
  }

  .proLine {
    height : auto;
  }

  .proLine .el-image {
    margin : 15px 0;
  }

  .num {
    width       : 100%;
    line-height : 40px;
    margin      : 0;
  }

  .price, .delete {
    line-height : 40px;
    font-size   : 18px;
  }

  .shopList {
    padding : 0;
  }

  .btns {
    height : 45px;
  }

  .boxBtn {
    width        : 45%;
    margin-right : 3%;
    font-size    : 20px;
    height       : 40px;
    line-height  : 40px;
  }

  .title {
    line-height : 25px;
    font-size   : 16px;
    margin-top  : 5px;
  }

  /deep/ .el-input-number__increase, /deep/ .el-input-number__decrease, /deep/ .el-input-number__decrease.is-disabled {
    width       : 30px;
    height      : 30px;
    line-height : 30px;
  }

  /deep/ .el-input-number .el-input__inner {
    padding     : 0 32px;
    height      : 30px;
    line-height : 30px;
  }

  /deep/ .el-input-number {
    max-width   : 120px;
    line-height : 30px;
  }

  .rightText, .rightPrice {
    font-size : 16px;
  }
}

/*平板*/
@media screen and (min-width : 768px) and (max-width : 992px) {
  /deep/ .el-dialog {
    width : 75%;
  }

  .title {
    line-height : 28px;
    font-size   : 18px;
    margin-top  : 12px;
  }

  /deep/ .el-input-number__increase, /deep/ .el-input-number__decrease, /deep/ .el-input-number__decrease.is-disabled {
    width       : 30px;
    height      : 30px;
    line-height : 30px;
  }

  /deep/ .el-input-number .el-input__inner {
    padding : 0 32px;
    height  : 30px;
  }

  /deep/ .el-input-number {
    max-width   : 100px;
    line-height : 30px;
  }

  .num {
    margin      : 0 10px;
    height      : 56px;
    line-height : 56px;
  }

  .price, .delete {
    line-height : 56px;
    font-size   : 18px;
  }

  .rightText, .rightPrice {
    font-size : 18px;
  }
}

/*中等屏幕*/
@media screen and (min-width : 992px) and (max-width : 1200px) {
  .title {
    height      : 60px;
    line-height : 30px;
    font-size   : 20px;
    margin-top  : 10px;
  }

  /deep/ .el-input-number__increase, /deep/ .el-input-number__decrease, /deep/ .el-input-number__decrease.is-disabled {
    width       : 32px;
    height      : 32px;
    line-height : 32px;
  }

  /deep/ .el-input-number .el-input__inner {
    padding : 0 35px;
    height  : 35px;
  }

  /deep/ .el-input-number {
    max-width   : 120px;
    line-height : 35px;
  }

  .num {
    margin      : 0 10px;
    line-height : 60px;
  }

  .price, .delete {
    font-size   : 20px;
    line-height : 60px;
  }

  .rightText, .rightPrice {
    font-size : 20px;
  }
}

/*大屏幕*/
@media screen and (min-width : 1200px) {

}
</style>



// WEBPACK FOOTER //
// src/common/ShopCartBox.vue